import { Scenario } from "@reco/shared/src/constants";
import type { Recommendation } from "@reco/shared/src/types/recommendation";

/**
 * Configuration interface for flexible scenario data-types (PRECO-4029)
 * Used to parse and structure information from complex data-type strings
 */
export interface FlexibleScenarioConfig {
  baseScenario: Scenario.BESTSELLERS;
  targetType: TargetType;
  categoryLevel?: number;
  source: SourceType;
}

export enum TargetType {
  CATEGORY = "category",
  BRAND = "brand",
}

export enum SourceType {
  URL = "url",
  HISTORY = "history",
}

export interface ProductVisit {
  contextId?: string;
  scenario: Scenario;
  recommendationItems: Recommendation[];
  categoryPath?: string;
  categoryPathName?: string;
  brand?: string;
  brandName?: string;
}

export interface ProductVisitRecord {
  timestamp: number;
  params: {
    contextProduct: string;
    contextId?: string;
    categoryPath?: string;
    categoryPathName?: string;
    brand?: string;
    brandName?: string;
    scenario?: Scenario;
    tradeType?: "retail" | "online" | "both";
  };
  response: {
    recommendationItems: Recommendation[];
  };
}

export interface PersonalBrandRecord {
  timestamp: number;
  brand: string;
  brandName: string;
  count: number;
}

export interface PersonalCategoryRecord {
  timestamp: number;
  categoryPath?: string;
  categoryPathName?: string;
  count: number;
}
